module.exports = __webpack_public_path__ + "static/media/Grid2_2.58b356bd.jpeg";